interface TabPanelProps<T> {
  children?: React.ReactChild
  currentValue: T
  value: T
}

export const TabPanel = <T extends unknown>({
  children,
  currentValue,
  value,
}: TabPanelProps<T>) => (
  <div
    role="tabpanel"
    hidden={value !== currentValue}
    id={`simple-tabpanel-${value}`}
    aria-labelledby={`simple-tab-${value}`}
  >
    {children}
  </div>
)
